// src/pages/CartPage.jsx
import React from 'react';
import ShoppingCart from '../components/ShoppingCart'; // Chỉ import ShoppingCart

function CartPage() {
  return (
    <ShoppingCart />
  );
}

export default CartPage;